import { all, fork } from 'redux-saga/effects';
import { offersSaga } from './offers';
import { rateQuotesSaga } from './rate-quotes';

export const rateQuoteSaga = function*() {
  yield all([fork(offersSaga), fork(rateQuotesSaga)]);
};
